<template>
 
  <div id="Vue"  >
 
 	<el-dialog
	  title="使用说明"
	  :visible.sync="dialogVisible1"
	  width="50%" >
 
	      <span style='font-weight:bold'>  操作方法说明：</span>
		  </br>
		  <span>1, 智利，阿根廷，哥伦比亚，厄瓜多尔等一些南美国家产品描述数据为西班牙语，俄罗斯，哈萨克斯坦等为俄语，按产品描述搜索的时候根据提示输入相应语种。 </span>
		  </br>
		  <span>2, 因为很多国家的原始海关数据，包括货物描述，采购商，供应商等一些字段信息就不完整，所以搜索的时候建议选择HS编码进行搜索 </span>
		  </br>
		  <span>3, HS编码搜索的时候，各个国家保留的位数不尽一致，所以尽可能输入前六位进行搜索！   </span>
		  </br>
		  <span>4, 目前免费用户可以查询首页数据,  VIP用户不受限制.     </span>
		  </br>
		  <span>5, 关于货值和数量 ，有的国家如美国是一行记录显示一批货物的情况，而有的国家如印度则是每一行显示货物的ITEM明细记录。      </span>
		  		  
		  <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible1 = false">取 消</el-button> 
		  </span>
	</el-dialog>  
	
<el-dialog
  title="提单明细"
  :visible.sync="dialogVisible"
  width="90%" >
  <span>提单号：{{form.bl_number}}</span>
  <el-descriptions class="margin-top" title="" :column="3" size="medium" border>
 
    <el-descriptions-item label="日期">{{form.dt}}</el-descriptions-item>
    <el-descriptions-item label="供应商"><div v-html= "form.shipper_name"></div></el-descriptions-item>
    <el-descriptions-item label="地址">{{form.shipper_address}}</el-descriptions-item>
    <el-descriptions-item label="采购商">
      <el-tag size="normal"><div v-html= "form.consignee_name"></div></el-tag>
    </el-descriptions-item>
    <el-descriptions-item label="地址">{{form.consignee_address}}</el-descriptions-item>

	<el-descriptions-item label="装运港">{{form.loading_port}}</el-descriptions-item>
	<el-descriptions-item label="卸货港">{{form.unloading_port}}</el-descriptions-item>
	<el-descriptions-item label="HS编码">{{form.hs_code}}</el-descriptions-item>
	<el-descriptions-item label="货物描述"> 
                            <div v-html= "form.product_desc"></div> 
	</el-descriptions-item>
	<el-descriptions-item label="重量(kg)">{{form.weight}}</el-descriptions-item>
	<el-descriptions-item label="包装数">{{form.pkg_number}}</el-descriptions-item>
	<el-descriptions-item label="数量">{{form.qty_number}} {{form.qty_unit}} </el-descriptions-item>	
	
	<el-descriptions-item label="单价">{{form.fob_unit}}   </el-descriptions-item>
	<el-descriptions-item label="货值">{{form.fob_total}}   </el-descriptions-item>
  </el-descriptions>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button> 
  </span>
</el-dialog>
	
 <el-row >
  <el-col :span="22" :offset="1"> 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"   >
  <el-breadcrumb separator-class="el-icon-arrow-right" style="  margin-top:3px;margin-left:10px;margin-bottom:30px;">
  <el-breadcrumb-item :to="{ path: '/customs/index' }">海关数据</el-breadcrumb-item>
  <el-breadcrumb-item>数据搜索</el-breadcrumb-item>  
  
    <div style="float:right">
    <el-button size="mini" icon="el-icon-warning-outline"   @click="dialogVisible1 = true" plain >使用说明</el-button>
  </div> 
  </el-breadcrumb>   
  <el-form ref="form"  :inline="true" :model="form" label-width="60px" class="demo-form-inline" style="margin-top:10px;">
  <el-form-item label="国家" v-loading="loading">
    <el-select @change="nationselectChanged" v-model="form.region" placeholder="请选择国家" style="width:180px">
                            <el-option
                                    v-for="item in cateOptions"
                                    :key="item.countryCode"
                                    :label="item.countryName"
                                    :value="item.countryCode">
                            </el-option>	
  
    </el-select>
  </el-form-item> 
  <el-form-item label="类别">
    <el-select @change="selectChanged" v-model="form.type" placeholder="请选择"  style="width:120px">
      <el-option label="产品描述" value="des"></el-option>
	  <el-option label="HS编码" value="hs"></el-option>
      <el-option label="供应商" value="sup"></el-option>
	  <el-option label="采购商" value="cli"></el-option> 	  
    </el-select>
  </el-form-item>   
  <el-form-item label="关键词">
     <el-input v-model="form.keywords" :placeholder="place"  @keyup.enter.native="onSubmit" style="width:320px" ></el-input> 
  </el-form-item>
  <el-form-item>
    <el-button type="primary" :loading="loading" @click="onSubmit" >查贸易数据</el-button> <!-- v-if="searchType=='hs' || searchType=='des' || searchType=='cli'" --> 
	<el-button type="success" :loading="loading" @click="queryCli" >查采购商</el-button>
	<el-button type="primary" :loading="loading" @click="querySup" plain >查供应商</el-button>
  </el-form-item>

  </el-form>
  </el-row>
  
  <el-row style=" padding:20px;margin-top:10px;background: #fff; " justify="left" v-if="queryType=='cli' || queryType=='sup'"  >  
    <el-skeleton v-if="loading == true"  :rows="6" animated />
    <div class="form-table-box">
             
                <div v-for="(item,index) in tableData  ">
                <div  class="list-wrap clearfix"  v-if="item.company_name != 'N/A' && item.company_name != '' &&  item.company_name != null" >
                 <!--router-link to="/dashboard/sup">
					<el-button type="primary" icon="plus"></el-button>
				</router-link-->
                    <div class="header clearfix" v-if="item.company_name != 'N/A'">
                        <div class="h1">
                            <div class="in1">
                                 
                                <div class="goods-num" style="color:#111; font-size: 26px;"> {{item.company_name}} </div>
                            </div>
							<div class="in1">
                                 
                                <div style=" background: #594d72;font-size: 24rpx;color: #fff;border-radius: 8rpx;padding: 8px 10px;"> {{item.country_name}} </div>
                            </div>
                            <!--div class="in1">
                                 
                                <div class="goods-num"  style="color:#999;">
								 
								<el-button type="primary" plain size="mini"  v-if="item.sub==0" @click="handleSub(index )"> 关注 </el-button>
								<el-tag type="success" icon="el-icon-check" v-if="item.sub==1">已关注</el-tag>
								 
								</div>
                            </div>
                            <img :src="item.pic_url" style="width: 50px;height: 40px" class="goods-img"-->
                        </div>
                       
                        

                    </div>
                    <div class="content-wrap clearfix"  v-if="item.company_name != 'N/A'">
					
                            <div class="content">
                                <div class="c1">
                                    <div class="goods-name" style="width:90%"> 相关贸易记录</div> 
                                </div>
                                <div class="c2">
                                    <div class="goods-number">日期：{{item.dt}}</div> 
                                </div>  								
                                <div class="c2"> 货物描述：
                                    <div class="goods-number" v-html="item.product_desc"> </div> 
                                </div>								
                             								
                            </div>
                    </div>
					<!-- <el-divider  v-if="item.company_name != 'N/A'"> </el-divider>  -->
					<div style="margin-top:20px" >
					 <el-button plain type="primary" size="mini"    @click="handleReport_company(item.company_name)">查看公司报告</el-button> 
					 <el-button plain type="success" size="mini"    @click="handleReport_leader(item.company_name)">搜公司决策者</el-button> 
					 
					</div>
				  </div>
                </div>
                <div class="page-box">
				  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end; margin-right:10px; ">
				  <el-tag v-show="!loading " style="margin-right:5px;">当前:第{{page}}页</el-tag>
				  <el-tag v-show="!loading  " style="margin-right:5px;">{{countInfo}}</el-tag>
 
				  <el-button-group v-show="!loading " >
				  <el-button type="primary" icon="el-icon-arrow-left" size="mini" :disabled="status" @click="getCompany('prev')">上一页</el-button>
				  <el-button type="primary" size="mini" :disabled="status" @click="getCompany('next')">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
				  </el-button-group>
				  </div>
                </div>
            </div>
  </el-row> 
  
  <el-row style=" padding:20px;margin-top:10px;background: #fff; " justify="left" v-if="queryType=='detail'"    >  
 
   
  <el-table id="tbl" v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%;height:600px"
	
     >
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==0" 
      width="1%">
    </el-table-column>
    <el-table-column
      fixed
      prop="dt"
      label="日期"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="hs_code"
      label="HS编码"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="product_desc"
      label="货物描述"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.product_desc"></div>
          </template> 
    </el-table-column>
    <el-table-column
      prop="consignee_name"
      label="采购商"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.consignee_name"></div>
          </template> 
    </el-table-column>	
    <el-table-column
      prop="shipper_name"
      label="供应商"
      min-width="20%">
	  	  <template slot-scope="scope">
                            <div v-html="scope.row.shipper_name"></div>
          </template> 
    </el-table-column>		
    <el-table-column
      prop="prod_weight"
      label="重量(kg)"
      min-width="10%">
    </el-table-column>
    <el-table-column
      prop="country_name"
      label="国家"
      min-width="10%">
    </el-table-column>	
 
	
    <el-table-column 
      label="操作" 
	  width="236"
      min-width="10%">
	  	 <template slot-scope="scope">
				<el-button   size="mini"   @click="handleDetail(scope.$index, scope.row)">提单明细</el-button>
				 
                <el-button plain type="warning" size="mini" v-if="scope.row.consignee_name != 'N/A'"   @click="handleReport3(scope.$index, scope.row)">采购商决策者</el-button> 
				</br>  </br>
				<el-button plain type="success" size="mini" v-if="scope.row.consignee_name != 'N/A'"   @click="handleReport1(scope.$index, scope.row)">采购商报告</el-button>
				<el-button plain type="primary" size="mini" v-if="scope.row.shipper_name != 'N/A'"   @click="handleReport2(scope.$index, scope.row)">供应商报告</el-button> 
		 </template>
    </el-table-column>
  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">
  <el-tag v-show="!loading " style="margin-right:5px;">当前:第{{page}}页</el-tag>
  <el-tag v-show="!loading " style="margin-right:5px;">共:{{total}}条</el-tag>
  <!--el-pagination v-show="!loading " @current-change="handlePageChange" :current-page="page" :page-size="10" layout="total, prev, pager, next" :total="total">
				</el-pagination--> 
  <el-button-group v-show="!loading" >
  <el-button type="primary" icon="el-icon-arrow-left" size="mini" :disabled="status" @click="getInfo('prev')">上一页</el-button>
  <el-button type="primary" size="mini" :disabled="status" @click="getInfo('next')">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
  </el-button-group>
  </div>
  </el-row> 
  
  
  </el-col>
  </el-row>
</div>
</template>





<script>
 
export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {},
			loading: false,
			login_state : false,
			id: 20000000,
			user_id: 0,
			is_vip: 0,
			page: 1,
			size:10,
		    total: 0,
			countInfo: '',
			buttonQuery: 1,
			queryType: 'detail',
			dialogVisible: false,
			dialogVisible1: false,
			status:true,
			place: '',
			searchType: 'des',
			isLast: 0,
			isProcess: 0,
			searchWordArr: [],
			cateOptions: [],
			form:{ region:'', 
			       keywords:'',
				   type: '', 
				   
				   bl_number: '',
				   dt: '',
				   shipper_name: '',
				   shipper_address:'',
				   consignee_name:'',
				   consignee_address: '',
				   notify_name:'',
				   Vessel_name:'',
				   loading_port: '',
				   unloading_port: '',
				   hs_code: '',
				   product_desc: '',
				   weight: 0,
				   CBM:0,
				   pkg_number:'',
				   qty_number:'',
				   pkg_unit:'',
				   qty_unit:'',
				   fob_unit:'',
				   fob_currency:'',
				   fob_total:'',
				   
				 },
			tableData:[],
			nextPageData: [],
			prevPageData: [],
			}  
        },
        methods: {
		    handleDetail(index, row){
			   localStorage.setItem('billId', row.id);
			   let info = this.tableData[index]; 
			   let that = this;
			   $.ajax({
					  type: "POST",
					  data:  { 
							ref_table: that.tableData[index].ref_table,
							ref_id: that.tableData[index].ref_id,  
							  },
					  url: "https://www.myferp.com/admin/user/cdDetail",
					  dataType: "json",  
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: '请求失败!',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						  
						  console.log('detail:' + JSON.stringify(data.data.bl_number));
						  if (data.errno == 0){ 
							   that.form.bl_number = data.data.bl_number; 
							   that.form.dt = info.dt;
							   that.form.shipper_name = info.shipper_name;
							   that.form.shipper_address = data.data.shipper_address;
							   that.form.consignee_name = info.consignee_name;
							   that.form.consignee_address = data.data.consignee_address;
							   that.form.notify_name = data.data.notifyName;
							   that.form.Vessel_name = data.data.VesselName;
							   that.form.loading_port = data.data.loading_port;
							   that.form.unloading_port = data.data.unloading_port;
							   that.form.hs_code = info.hs_code;
							   that.form.product_desc = info.product_desc;
							   that.form.weight = info.weight + ' Kgs';
							   that.form.CBM = data.data.MEACBM;
							   that.form.pkg_number = data.data.pkg_number  + data.data.pkg_unit ; 
							   that.form.qty_number = data.data.qty_number  + data.data.qty_unit ; 
							   that.form.fob_unit =  data.data.fob_currency + data.data.fob_unit  ;
							   that.form.fob_total =  data.data.fob_currency + data.data.fob_total ;
							   that.dialogVisible = true;
							   						  
							  return;
						     } 
							  
						    }  
					  });
			 /*  that.form.bl_number = info.bl_number; 
			   that.form.dt = info.dt;
			   that.form.shipper_name = info.shipper_name;
			   that.form.shipper_address = info.shipper_address;
			   that.form.consignee_name = info.consignee_name;
			   that.form.consignee_address = info.consignee_address;
			   that.form.notify_name = info.notifyName;
			   that.form.Vessel_name = info.VesselName;
			   that.form.loading_port = info.loading_port;
			   that.form.unloading_port = info.unloading_port;
			   that.form.hs_code = info.hs_code;
			   that.form.product_desc = info.product_desc;
			   that.form.weight = info.weight + ' Kgs';
			   that.form.CBM = info.MEACBM;
			   that.form.pkg_number = info.pkg_number  + info.pkg_unit ; 
			   that.form.qty_number = info.qty_number  + info.qty_unit ; 
			   that.form.fob_unit =  info.fob_currency + info.fob_unit  ;
			   that.form.fob_total =  info.fob_currency + info.fob_total ;
			   that.dialogVisible = true; */
			   
			},
			handleReport1(index, row){ 
				if (this.user_id == 0){
				    this.$message({
							message: '注册并登录后即可免费查看 ! ',
							type: 'warning'
							});
					return;
				} 
			   let that = this; 
			   let isVip = 0;
			   if (that.page != 1){//(that.form.region != 'us' && that.form.region != 'ru' && that.form.region != 'pe'){ 									  
					if (that.is_vip == 0){ 
							that.$message({
							message: '免费用户不能查看该公司报告! ',
							type: 'error'
							});
							return;
						}
							 
					}
			   let txt = this.toText(row.consignee_name);
			   let newUrl = that.$router.resolve({
					  path: '/customs/customsReport',
					  query: {
								companyName: txt,
								companyAddress: row.consignee_address,
								companyType: 'importer',
								region: that.form.region,
							  }
					 });
			   window.open(newUrl.href, "_blank");	

			},
			toText(content){
			  return content.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');
			},

			handleReport2(index, row){ 
				if (this.user_id == 0){
				    this.$message({
							message: '注册并登录后即可免费查看 ! ',
							type: 'warning'
							});
					return;
				} 
			   let that = this; 
			   let isVip = 0;
			   if (that.form.region != 'us' && that.form.region != 'ru' && that.form.region != 'pe'){
					if (that.is_vip == 0){ 
							that.$message({
							message: '免费用户不能查看此国家的公司报告! ',
							type: 'error'
							});
							return;
						}
					}
			   let txt = this.toText(row.shipper_name);
			   let newUrl = that.$router.resolve({
					  name: 'customsReport',
					  query: {
					            companyName: txt,
								companyAddress: row.shipper_address,
								companyType: 'exporter',
								region: that.form.region
					          }
				     });
			   window.open(newUrl.href, "_blank");
			},
			handleReport3(index, row){  
				if (this.user_id == 0){
				    this.$message({
							message: '注册并登录后即可查看 ! ',
							type: 'warning'
							});
					return;
				} 
               localStorage.setItem('companyName',  row.consignee_name );
			   localStorage.setItem('companyAddress',  row.consignee_address );
               localStorage.setItem('companyType',  'importer' ); 
			   localStorage.setItem('region',  this.form.region ); 
			   let txt = this.toText(row.consignee_name);
			   let newUrl = this.$router.resolve({
					  path: '/customs/customsContact',
					  query: {
					            companyName: txt, 
					          }
				     });
			   window.open(newUrl.href, "_blank");
			},
			handleReport_leader(val){
				if (this.user_id == 0){
				    this.$message({
							message: '注册并登录后即可查看 ! ',
							type: 'warning'
							});
					return;
				} 
				if (this.page > 1 && this.is_vip == 0 ){
				    this.$message({
							message: '升级VIP用户后查看 ! ',
							type: 'warning'
							});
					return;
				}
               localStorage.setItem('companyName', val );
			   localStorage.setItem('companyAddress',  '' );
               localStorage.setItem('companyType',  'importer' ); 
			   localStorage.setItem('region',  this.form.region ); 
			   let newUrl = this.$router.resolve({
					  path: '/customs/customsContact',
					  query: {
					            companyName: val, 
					          }
				     });
			   window.open(newUrl.href, "_blank");			
			},
			handleReport_company(val){
				if (this.user_id == 0){
				    this.$message({
							message: '注册并登录后即可免费查看 ! ',
							type: 'warning'
							});
					return;
				}
				if (this.page > 1 && this.is_vip == 0 ){
				    this.$message({
							message: '升级VIP用户后查看 ! ',
							type: 'warning'
							});
					return;
				}
				let companyType = 'exporter';
                if (this.queryType == 'cli')
                    companyType = 'importer';				
			    let newUrl = this.$router.resolve({
					  name: 'customsReport',
					  query: {
					            companyName: val,
								companyAddress: '',
								companyType: companyType,
								region: this.form.region ,
					          }
				     });
			   window.open(newUrl.href, "_blank");				
			},
		    handleSelect(key, keyPath) {
	           if (key == 1)
			      this.back();
				  
	           if (key == 2)
			      this.login();				  
			},
			handlePageChange(val) {
				this.page = val;
				this.buttonQuery = 0;
				//保存到localStorage
				localStorage.setItem('adPage', this.page)
				localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
				this.getInfo('uk');
			},
			nationselectChanged(value){
			  if (this.form.type == 'des'){
				  if (value == 'ru' || value == 'ka')  
					  this.place = '建议输入俄语，例如 ДЛЯ СУДОВ'; 					  
				  else
 				     if  (value == 'ch' || value == 'pe' || value == 'co'   || value == 'ec' || value == 'ar' )
					      this.place = '建议输入西班牙语，例如 ACCESORIO DE';
					 else
					       this.place = '建议输入英语，例如 AUTO PARTS';
			  }
			},
			selectChanged(value) {
			  if (value == 'des'){
			      if  (this.form.region == 'ru' || this.form.region == 'ka' )
			          this.place = '建议输入俄语，例如 ДЛЯ СУДОВ'; 					  
			      else if  (this.form.region == 'ch' || this.form.region == 'pe' || this.form.region == 'co'   || this.form.region == 'ec' || value == 'ar' )
			          this.place = '建议输入西班牙语，例如 ACCESORIO DE';
				  else
				      this.place = '建议输入英语，例如 AUTO PARTS';
				  this.searchType = 'des';
				  }
			  if (value == 'cli'){
			      this.place = '请输入采购商名称，例如HONEYWELL INC'; 
				  this.searchType = 'cli';
				  }
			  if (value == 'sup'){
			      this.place = '请输入供应商名称，例如SHANGHAI BAOLONG';
				  this.searchType = 'sup';
				  }		
			  if (value == 'hs'){
			      this.place = '建议输入hs code前六位，例如730799';
				  this.searchType = 'hs';
				  }	
			  this.form.keywords = '';  
			},
			handleSub(index){   //关注公司

				let that = this;   
				if (that.user_id == 0 ) {
				    that.$message({
							message: '请先登录 ! ',
							type: 'success'
							});
				    return;
				}
 
				console.log('index: ' + index);	
				that.loading = true;
                $.ajax({
					  type: "POST",
					  data:  { 
							company_name: that.tableData[index].company_name,
							user_id: that.user_id, 
							source: 'customs',
							  },
					  url: "https://www.myferp.com/admin/linkedIn/subCompany",
					  dataType: "json",  
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: '请求失败!',
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						  
						  console.log(JSON.stringify(data));
						  if (data.errno == 0){ 
						      that.tableData[index].sub = 1;
						      that.$message({
							  message: '成功关注!  ',
							  type: 'success'
							  });
							  that.loading = false;	
                              that.status = true;	
							   						  
							  return;
						     } else{
						      that.$message({
							  message: '关注失败!  ',
							  type: 'error'
							  });							 
						      that.loading = false;	
                              that.status = false;
							  }
							  
						    }  
					  });
			},	 
			
		    onSubmit(){
				if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}	
				if  (this.is_vip == 0 && this.form.region != 'all'){
				    this.$message({
							message: '免费用户只能按全部国家进行搜索 ! ',
							type: 'warning'
							});
				    return;
				}					
			    this.queryType = 'detail'; 
			    this.page = 1; 
				this.buttonQuery = 1;
				$("#dataList").removeProp("height");
				this.getInfo('query');
				},
				
		    queryCli(){
				if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}	
				if  (this.is_vip == 0 && this.form.region != 'all'){
				    this.$message({
							message: '免费用户只能按全部国家进行搜索 ! ',
							type: 'warning'
							});
				    return;
				}				
			    this.queryType = 'cli'; 
			    this.page = 1; 
				this.buttonQuery = 1;
				$("#dataList").removeProp("height");
				this.getCompany('query');
				},

		    querySup(){
				if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}	
				if  (this.is_vip == 0 && this.form.region != 'all'){
				    this.$message({
							message: '免费用户只能按全部国家进行搜索 ! ',
							type: 'warning'
							});
				    return;
				}				
			    this.queryType = 'sup';
			    this.page = 1; 
				this.buttonQuery = 1;
				$("#dataList").removeProp("height");
				this.getCompany('query');
				},	
				
			getCompanyInfo(val){
			    
			/*
			   if (val == 'next'){
			      if (this.nextPageData.length != 0){
			         this.prevPageData = this.tableData;
			         this.tableData = this.nextPageData;
				   
				     }
				   }
			   if (val == 'prev'){
			      if (this.curPage == 1){
				    this.$message({
							message: '已到首页 ! ',
							type: 'warning'
							});
				    return;
				    }
			      if (this.prevPageData.length != 0){
			         this.prevPageData = this.tableData;
			         this.tableData = this.nextPageData;
				   
				     }
				   }	*/				   
			},
			
			getInfo(val){
				let that = this; 

				if (val == 'next'){
				    if (that.page * 10 >= that.total){
				    that.$message({
							message: '已到末页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   }
				if (val == 'prev'){
				    if (that.page == 1){
				    that.$message({
							message: '已到首页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   } 
				let curPage = 0;
				if (val == "next"){
				    curPage = that.page + 1 ; 
					that.id = that.tableData[9].id;
					}
			    if (val == "prev"){
				    curPage = that.page - 1 ;
					that.id = that.tableData[0].id;
					}
				if (val == "query")
				    curPage = 1 ;

					
				if ( that.user_id == 0  && curPage > 1){
				    that.$message({
							message: '请登录后查看更多 ! ',
							type: 'success'
							});
				    return;
				}
				that.loading = true;
				
				  $.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id, 
					          page: curPage, 
							  size: 10,
							  count: that.total,
                              id: that.id,							  
							  region: that.form.region,
							  type:that.form.type,
							  keywords:that.form.keywords,
							  buttonQuery: that.buttonQuery,
							  direction: val,
							  },
					  url: "https://www.myferp.com/admin/user/querySearch",//"http://127.0.0.1:8362/admin/user/querySearch", 
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						console.log(JSON.stringify(data));
						if (data.errno == 500){
						      that.$message({
							  message: '未查询到相关数据， 换个词试试! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 300){ //未付费注册用户查询不超过5页
						      that.$message({
							  message: '免费用户, 随机提取该国数据! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 200){  //非注册用户每天查询最多两次
						      that.$message({
							  message: '登录后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 100){  //未付费注册用户每天查询最多五次
						      that.$message({
							  message: '成为会员后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						that.tableData = data.data.data ; 
						that.searchWordArr = that.form.keywords.trim().split(" "); 
						that.highLightWord();
						that.page = parseInt(data.data.currentPage);
						that.total = parseInt(data.data.count);
						if (that.total >= 1) 
						     $("#tbl").attr("style","width:100%");
						else 
						     $("#tbl").attr("style","width:100%;height:500px");
						that.id = data.data.id;
						that.loading = false;	
                        that.status = false;	
						if (data.data.user == 'free') //未付费 用户提示
						      that.$message({
							  message: '免费用户, 随机提取该国数据! ',
							  type: 'error'
							  });						
						}
					  });
		    },
            getCompany(val){          //查采购商
				let that = this;   
				

				if (val == 'next'){
				    if (that.page * 10 >= that.total){
				    that.$message({
							message: '已到末页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   }
				if (val == 'prev'){
				    if (that.page == 1){
				    that.$message({
							message: '已到首页 ! ',
							type: 'error'
							});
				    return;
				    }  
				   } 
				let curPage = 0;
				if (val == "next"){
				    curPage = that.page + 1 ; 
					that.id = that.tableData[9].id;
					}
			    if (val == "prev"){
				    curPage = that.page - 1 ;
					that.id = that.tableData[0].id;
					}
				if (val == "query")
				    curPage = 1 ;

					
				if ( that.user_id == 0  && curPage > 1){
				    that.$message({
							message: '请登录后查看更多 ! ',
							type: 'success'
							});
				    return;
				}
				that.loading = true;
				that.tableData = [];
				$.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id, 
					          page:  curPage, 
							  size: 10,
							  count: that.total,
                              id: that.id,							  
							  region: that.form.region,
							  type:that.form.type,
							  keywords:that.form.keywords,
							  buttonQuery: that.buttonQuery,
							  companyType :that.queryType,
							  direction: val,
							  },
					  url: "https://www.myferp.com/admin/user/getCompany",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						console.log(JSON.stringify(data));
						if (data.errno == 500){
						      that.$message({
							  message: '未查询到相关数据， 换个词试试! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 300){ //未付费注册用户查询不超过5页
						      that.$message({
							  message: '免费用户不能查询此国公司数据! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 200){  //非注册用户每天查询最多两次
						      that.$message({
							  message: '登录后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 100){  //未付费注册用户每天查询最多五次
						      that.$message({
							  message: '成为会员后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  $("#tbl").attr("style","width:100%;height:500px");
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						that.tableData = data.data.data ; 
						if (that.tableData == 0){
							that.$message({
									message: '已到末页 ! ',
									type: 'error'
									});
							that.loading = false;
							return;
						}
						that.page = parseInt(data.data.currentPage);
						that.total = parseInt(data.data.count);
						if (val == 'query')  
						    that.countInfo = '共:' + parseInt(that.total )+'条'; 
						
						if (that.total >= 1) 
						     $("#tbl").attr("style","width:100%");
						else 
						     $("#tbl").attr("style","width:100%;height:500px");
						that.id = data.data.id;
						that.loading = false;	
                        that.status = false;
						/*
						if (data.data.data.length == 10){
						    that.isProcess = 1;
							that.axios.post('http://localhost:8362/admin/user/queryCompany', 
											{user_id: that.user_id, 
								  page: curPage + 1, 
								  size: 10,
								  count: that.total,
								  id: that.id,							  
								  region: that.form.region,
								  type:that.form.type,
								  keywords:that.form.keywords,
								  buttonQuery: that.buttonQuery,
								  company_type :that.queryType,
								  direction: 'next',
								   }).then((response) => {
							if (response.data.errno == 0) {
							    that.isProcess = 0;
								that.nextPageData = response.data.data;
							   }
	 
							})
							}
							*/


						
						
						}
					  });
		    },
			login()
			{
			   
			  window.location.href= '/login';  
			},

			back()
			{ 
			  window.location.href= '/';  
			},
			 
			highLightWord() {
			    
				this.tableData.map((item) => { 
					//要匹配的哪些字段，都要进行`brightKeyword`方法来遍历处理
					item.product_desc = item.product_desc && this.brightKeyword(item.product_desc)
					item.consignee_name = item.consignee_name && this.brightKeyword(item.consignee_name)
					item.shipper_name = item.shipper_name && this.brightKeyword(item.shipper_name);
				})
			},

			getCountry(){
			   let that = this;
			   that.loading = true;
			   $.ajax({
				  type: "post",
				  data:  {   },
				  url: "https://www.myferp.com/admin/auth/countryList",
				  dataType: "json",  //返回类型为 json    
				  error: function(XMLHttpRequest, textStatus, errorThrown) { 
				    that.loading = false;
				  },
				  success: function (data) {
				    that.loading = false;
					console.log('country info:' + JSON.stringify(data));
					
					that.cateOptions = data.data.info; 
					var all = {};
					all.countryCode = 'all';
					all.countryName = '全部';
					that.cateOptions.unshift(all);
				  }
			   });
			},
			getVipInfo(){
			   let that = this;
				   that.$axios.get ('https://www.myferp.com/admin/user/isVip',{
								  headers:{ 
								 "X-Nideshop-Token": localStorage.getItem('token')},
								 params: {user_id: that.user_id }
								 }).then((response) => {
								console.log('category: ' + JSON.stringify(response) );
								if (response.data.errno == 0) { 
									that.is_vip = response.data.data.isVip; 
									 
									}
		 
								})
			
			},
			brightKeyword(val) {
			    
				var reg = new RegExp(`${this.searchWordArr.join('|')}`, 'gi');
				var str = val.match(reg); 
				str && str.forEach(s => {
					return val = val.replace(s,  `<span style='font-weight:bold;'>${s}</span>` );
				}) 
				return val;
			},
		},
        mounted() { 
		    this.getCountry();

		    this.form.type = 'des';
			this.form.region = 'all';
			this.place = '建议输入英语，例如 AUTO PARTS';
			var nation = this.$route.query.nation;
			if (nation != '' && nation != undefined && nation != null)
		    	this.form.region = nation;

			let userInfo = localStorage.getItem('userInfo');
			console.log( 'user:' + typeof userInfo); 
			console.log( 'user:' + userInfo); 
 
			let info = {};
		 
			if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				info = JSON.parse(userInfo);
				this.user_id = info.id;  
				this.login_state = true;
				}

 			this.getVipInfo();
           },		   
		
    } ;

 
	 
</script>


<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
  
    .el-pagination {
        padding-right: 30px;
        margin-bottom: 40px;
    }

    .top-wrap {
        padding: 0 12px;
    }

    .tabs-wrap {
        padding: 0 10px;
    }

    .filter-wrap {
        height: 42px;
        padding: 12px;
    }

    .main {
        padding: 50px 0;
    }

    .el-message-box {
        width: 300px !important;
    }

    .wrap {
        background: #fff;
		width: 100%;
		height: 100%;
    }

    .list-wrap {
        width: 100%;
        border: 1px solid #dfe5ed;
        margin-top: 12px; 
        padding: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }

    .header .h1 {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        border-bottom: 1px solid #f1f1f1;
    }

    .h1 .in1 {
        display: flex;
        justify-content: flex-start;
        align-items: center; 
    }

    .in1 .goods-num {
        margin-left: 4px;
        color: #ff3456;
    }

    .header .h2 {
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 13px;
        border-bottom: 1px solid #f1f1f1;
    }
    .price-change {
        float: right;
        margin-right: 10px;
        color: #e64242;
    }


    .content-wrap .goods-list {
        border-bottom: 1px solid #f1f1f1;
        padding: 12px 0;
        display: flex;
        justify-content: flex-start;
    }

    .goods-list .goods-img {
        width: 80px !important;
        height: 80px !important;
    }

    .content-wrap .content {
        padding-left: 2px;
        width: 98%;
        display: flex;
		 
        flex-direction: column; 
        font-size: 14px;
    }

    .content .c1 {
        width: 98%;
        height: 40px;
        line-height: 40px;
		overflow: hidden;
        display: flex;
        justify-content: flex-start;
    }

    .content .c2 {
        width: 98%;
        line-height: 40px;
        display: flex;
        justify-content: flex-start;

    }

    .content-wrap .goods-main {
        padding: 12px 0;
        border-bottom: 1px solid #f1f1f1;
    }

    .goods-main .to {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: #999;
        margin-bottom: 10px;
    }

    .goods-main .m1 {
        display: flex;
        flex-direction: column;
        font-size: 15px;
        line-height: 30px;
    }

    .goods-main .m2 {
        font-size: 15px;
        line-height: 30px;
    }

    .content-wrap .right {
        margin-top: 10px;
        display: flex;
        justify-content: flex-end;
    }

    .dialog-wrap .d-list-wrap {
        margin-bottom: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .dialog-wrap .d-goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size:14px;
        /*margin-bottom:20px;*/
        /*border-bottom:1px solid #d1dbe5;*/
    }

    .dialog-wrap .d-main {
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #d1dbe5;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

    .dialog-wrap .d-main div {
        font-size: 14px;
    }
    .d-hoho{
        margin-bottom:10px;
    }
    .d-haha{
        margin: 0;
    }
    .fahuo .el-dialog__body{
        padding:0 20px !important;
    }
</style>

 


// WEBPACK FOOTER //
// src/components/customs/customs.vue